import { useProfileService } from 'services/ProfileService';
import { EContractStatus } from 'types/teacherRecruitment';
import { useGetTeacherRecruitment } from './query/teacherRecruit/use-get-teacher-recruitment';

export const useLatestContractStatus = () => {
  const { profile } = useProfileService();
  const { data: teacherRecruitmentData, isLoading } = useGetTeacherRecruitment({
    enabled: !!profile.oneClubId,
  });

  const isContractEmpty =
    Object.keys(teacherRecruitmentData || {}).length === 0;

  const hasSignedLatestContract =
    !isContractEmpty &&
    teacherRecruitmentData?.contractStatus &&
    teacherRecruitmentData?.contractStatus === EContractStatus.ACCEPTED;

  return {
    isSigned: Boolean(hasSignedLatestContract),
    /**
     * 合約狀態還沒拿到。
     *
     * `isSigned` 是把三態（已簽／未簽／還不知道）壓成布林的結果，資料還沒回來時一律是 false，
     * 呼叫端若直接拿它做判斷，就會先以「未簽」的樣子渲染再自己修正。
     * 會因此閃一下的地方請先看這個旗標。
     *
     * `enabled` 為 false 時 React Query 的 isLoading 仍為 true，所以 profile 還沒回來的期間
     * 也會正確地停在「還不知道」。
     */
    isLoading,
  };
};
